<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-notification-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalNotification"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="modalNotification"
      tabindex="-1"
      aria-labelledby="modalNotificationLabel"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-danger">
            <div v-html="message" style="color: #f44335 !important;"></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalNotification",
  props: {
    message: {
      type: String,
      default: "",
    },
  },
};
</script>